mutation RestoreDripSequence($id: ID!) {
    campaignRestore(input: {id: $id}) {
        campaign {
            id
        }
    }
}
